import { LinearProgress, SxProps, Theme } from '@mui/material';

// const DEFAULT_DURATION_MS = 5000;
// const TICK_MS = 50;

/**
 * Renders a determinate linear progress bar that advances smoothly from 0% to 100%
 * over the given duration (default 5 seconds). Animation runs on mount and cleans up on unmount.
 */
export function LinearProgressLoader(props: { durationMs?: number; sx?: SxProps<Theme> }) {
  // const { durationMs = DEFAULT_DURATION_MS, sx } = props;
  // const [progress, setProgress] = useState(0);
  // const startTimeRef = useRef(0);
  // const durationMsRef = useRef(durationMs);
  // durationMsRef.current = durationMs;

  // useEffect(() => {
  //   startTimeRef.current = Date.now();
  //   setProgress(0);
  // }, [durationMs]);

  // useInterval(
  //   () => {
  //     const value = Math.min(
  //       100,
  //       ((Date.now() - startTimeRef.current) / durationMsRef.current) * 100,
  //     );
  //     setProgress(value);
  //   },
  //   progress >= 100 ? null : TICK_MS,
  // );

  return (
    <LinearProgress
      variant="indeterminate"
      // value={progress}
      sx={{ width: '100%', borderRadius: 4, opacity: 0.75, ...props.sx }}
    />
  );
}
